import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/dist/query';
import type { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import type {
  DigimonMove,
  MovesPaginatedListFilter,
} from 'Modules/FieldGuide/Types';
import type { PaginatedList, PaginationOptions, StoreEntities } from 'Store';
import { api, providesList } from 'Store';
import urlcat from 'urlcat';

export const movesApiSlice = api.injectEndpoints({
  endpoints: (
    build: EndpointBuilder<
      BaseQueryFn<
        string | FetchArgs,
        unknown,
        FetchBaseQueryError,
        {},
        FetchBaseQueryMeta
      >,
      StoreEntities,
      'api'
    >,
  ) => ({
    getMoveByID: build.query<DigimonMove, string | number>({
      providesTags: (result, error, arg) => [{ id: arg, type: 'Moves' }],
      query: (id) => `moves/${id}`,
    }),
    getMoves: build.query<
      PaginatedList<DigimonMove>,
      PaginationOptions<MovesPaginatedListFilter>
    >({
      providesTags: (result, error, arg) => providesList(result, 'Moves'),
      query: (options = { limit: 40 }) => urlcat('/moves', options),
    }),
  }),
});

export const { useGetMovesQuery, useGetMoveByIDQuery } = movesApiSlice;
